import React from 'react'
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline'

interface SortableTableHeaderProps {
  children: React.ReactNode
  sortKey: string
  currentSort: string
  sortOrder: 'asc' | 'desc'
  onSort: (key: string) => void
  className?: string
  /** Menos padding horizontal (tabelas densas) */
  compact?: boolean
}

export const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  children,
  sortKey,
  currentSort,
  sortOrder,
  onSort,
  className = '',
  compact = false
}) => {
  const isActive = currentSort === sortKey
  const pad = compact ? 'px-3 py-2' : 'px-6 py-3'
  
  return (
    <th 
      className={`${pad} text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <div className={`flex items-center space-x-1 ${className?.includes('text-center') ? 'justify-center' : ''}`}>
        <span>{children}</span>
        {isActive && (
          sortOrder === 'asc' ? 
            <ArrowUpIcon className="h-4 w-4" /> : 
            <ArrowDownIcon className="h-4 w-4" />
        )}
      </div>
    </th>
  )
}

export default SortableTableHeader
